import script from "./Spinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=f86cb61c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f86cb61c"]])

export default __exports__